<template v-if="hasHotel">
    <v-container>
        <v-row>
            <!-- Place ID: APENAS Admin Geral -->
            <template v-if="$isSystemAdmin()">
                <h3 class="col-12 title-class">Place ID do Hotel</h3>
                <v-col cols="12" md="8">
                    <v-text-field
                        ref="placeIdInput"
                        outlined
                        v-model="hotelPlaceId"
                        :rules="hotelPlaceIdRules"
                        label="Place ID"
                        required
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-tooltip :color="hasChangedPlaceId ? 'white' : 'primary'" bottom>
                        <template v-slot:activator="{ on }" >
                            <v-btn
                                v-on="on"
                                color="primary"
                                :outlined="!hasChangedPlaceId"
                                block
                                x-large
                                @click="openHotelPlaceIdConfirmationModal()"
                            >Alterar</v-btn>
                        </template>
                        {{ updatePlaceIdButtonLabel }}
                    </v-tooltip>
                </v-col>
            </template>

            <!-- Tokens de Acesso: Quem tem permissão manage.hotel-fare-update-tokens -->
            <v-col cols="12">
                <h3 class="col-12 title-class">Tokens de Acesso</h3>
                <div class="update-fares__token-card rounded-lg">
                    <div class="title-class color-grey-onfly text-center">
                        <span>Atualização de Tarifas</span>
                    </div>
                    <div class="send-token__btn-container">
                        Enviar novo Token de acesso para o hotel
                        <v-btn
                            small
                            outlined
                            class="rounded-lg"
                            color="primary"
                            @click="validateHotelAccessTokenChannels()"
                        >Enviar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <confirm-action-dialog
            :title="confirmActionDialog.title"
            :type="confirmActionDialog.type"
            :action-button-label="confirmActionDialog.buttonLabel"
            :model.sync="confirmActionDialog.model"
            :message="confirmActionDialog.message"
            @confirm="confirmActionDialog.action"
        />
        <response-dialog
            :model="responseDialog.dialog"
            :message="responseDialog.message"
            :type="responseDialog.type"
            @close="closeResponseDialogAndReload()"
        />
    </v-container>
</template>

<script>

import ResponseDialog from "../../Dialog/ResponseDialog.vue";
import ConfirmActionDialog from "../../Dialog/ConfirmActionDialog.vue";
import { ActionCodes } from "../../../types/HotelAccessTokenActionCodes";

export default {
    name: "AdminActions",
    components: { ConfirmActionDialog, ResponseDialog },
    props: {
        hotel: {
            type: Object,
            default: null
        },
    },
    data: () => ({
        confirmActionDialog: {
            title: '',
            type: '',
            buttonLabel: '',
            model: false,
            action: ''
        },
        responseDialog: {
            dialog: false,
            message: '',
            type: null
        },
        selectedChannels: [],
        hotelPlaceId: null,
        hotelPlaceIdRules: [
            v => !!v || 'O Place ID é obrigatorio',
            v => v.length >= 15 || 'O Place ID deve possuir pelo menos 15 caracteres',
        ]
    }),
    methods: {
        setData(){
            this.hotelPlaceId = this.hotel.place_id;
        },
        openResponseDialog (response, defaultMessage, dialogType) {
            this.cleanConfirmationModalData();
            this.responseDialog.message = response.data?.message ?? defaultMessage;
            this.responseDialog.type = dialogType;
            this.responseDialog.dialog = true;
        },
        closeResponseDialogAndReload () {
            this.cleanResponseDialogData();
            window.location.reload();
        },
        cleanResponseDialogData () {
            this.responseDialog.dialog = false;
            this.responseDialog.message = '';
            this.responseDialog.type = null;
        },
        openHotelPlaceIdConfirmationModal () {
            if (!this.isNewPlaceIdValidated) { return; }
            this.confirmActionDialog.title = 'Alterar Place ID';
            this.confirmActionDialog.type = 'warning';
            this.confirmActionDialog.buttonLabel = 'Alterar';
            this.confirmActionDialog.message = 'Certifique-se de que o Place ID é o mesmo cadastrado para a cidade do hotel no Luna!';
            this.confirmActionDialog.action = this.updateHotelPlaceId;
            this.confirmActionDialog.model = true;
        },
        openSendHotelAccessTokenConfirmationModal (message) {
            this.confirmActionDialog.title = 'Enviar Token de Acesso para Hotel';
            this.confirmActionDialog.type = 'warning';
            this.confirmActionDialog.buttonLabel = 'Enviar';
            this.confirmActionDialog.message = message;
            this.confirmActionDialog.action = this.sendHotelUpdateFaresAccessToken;
            this.confirmActionDialog.model = true;
        },
        validateHotelAccessTokenChannels () {
            axios.post(
                '/api/hotel/admin-actions/available-hotel-access-token-channels',
                this.getSendHotelUpdateFaresAccessTokenData(false),
                { validateStatus: () => true }
            ).then(response => {
                if (!response.data.success) {
                    this.openResponseDialog(response, 'Erro ao enviar, tente novamente mais tarde.', 'error');
                    return;
                }

                const { channels, canSendEmail, canSendWhatsApp } = response.data.data;
                this.selectedChannels = channels;

                if (!canSendEmail && !canSendWhatsApp) {
                    this.openResponseDialog({}, 'Hotel sem email e WhatsApp cadastrados. Não é possível realizar o envio.', 'error');
                    return;
                }

                if (!canSendEmail) {
                    this.openSendHotelAccessTokenConfirmationModal('Hotel sem email cadastrado. Deseja continuar enviando somente por WhatsApp?');
                    return;
                }

                if (!canSendWhatsApp) {
                    this.openSendHotelAccessTokenConfirmationModal('Hotel sem WhatsApp cadastrado. Deseja continuar enviando somente por e-mail?');
                    return;
                }

                this.openSendHotelAccessTokenConfirmationModal('Deseja mesmo enviar o token de acesso para que o hotel atualize suas tarifas? Caso o hotel já tenha um token ativo, o mesmo receberá um lembrete.');
            }).catch(() => {
                this.openResponseDialog({}, 'Erro ao enviar, tente novamente mais tarde.', 'error');
            });
        },
        cleanConfirmationModalData () {
            this.confirmActionDialog.model = false;
            this.confirmActionDialog.title = '';
            this.confirmActionDialog.type = '';
            this.confirmActionDialog.buttonLabel = '';
            this.confirmActionDialog.message = '';
            this.confirmActionDialog.action = null;
        },
        getPlaceIdUpdateData () {
            return {
                hotelId: this.hotel.id,
                placeId: this.hotelPlaceId
            }
        },
        updateHotelPlaceId () {
            axios.patch(
                '/api/hotel/admin-actions/update-place-id',
                this.getPlaceIdUpdateData(),
                { validateStatus: () => true }
            ).then(response => {
                response.data.success ?
                    this.openResponseDialog(response, 'O Place ID do hotel foi atualizado com sucesso!', 'success') :
                    this.openResponseDialog(response, 'Ocorreu um erro ao atualizar o Place ID do hotel', 'error');
            }).catch(error => {
                this.openResponseDialog({}, 'Ocorreu um erro ao atualizar o Place ID do hotel', 'error');
            });
        },
        sendHotelUpdateFaresAccessToken () {
            axios.post(
                '/api/hotel/admin-actions/generate-hotel-access-token',
                this.getSendHotelUpdateFaresAccessTokenData(),
                { validateStatus: () => true }
            ).then(response => {
                response.data.success ?
                    this.openResponseDialog(response, 'O token de acesso (ou lembrete) foi enviado com sucesso!', 'success') :
                    this.openResponseDialog(response, 'Erro ao enviar, tente novamente mais tarde.', 'error');
            }).catch(() => {
                this.openResponseDialog({}, 'Erro ao enviar, tente novamente mais tarde.', 'error');
            });
        },
        getSendHotelUpdateFaresAccessTokenData (includeChannels = true) {
            const data = {
                hotelId: this.hotel.id,
                actionCode: ActionCodes.IndividualUpdateFares
            }

            if (includeChannels) {
                data.channels = this.selectedChannels;
            }

            return data;
        },
    },
    computed: {
        hasHotel () {
            return this.hotel !== null;
        },
        hasChangedPlaceId () {
            return this.hasHotel && this.hotelPlaceId !== this.hotel.place_id;
        },
        updatePlaceIdButtonLabel () {
            return this.hasChangedPlaceId ? '' : 'Não existem alterações de Place ID a serem salvas';
        },
        isNewPlaceIdValidated () {
            return this.$refs.placeIdInput.validate() && this.hasChangedPlaceId;
        }
    },
    created() {
        if (this.hasHotel) {
            this.setData();
        }
    },
}
</script>

<style lang="scss" scoped>
.update-fares__token-card {
    border: 1px solid #F5F5F6;
    margin-bottom: 2rem;
    padding: 1rem;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

    .title-class span {
        padding: 0.25rem 0.5rem;
        font-size: 1.25rem;
        font-weight: 500;
        border: 1px solid #54667a;
        border-radius: 1.5rem;
    }

    .send-token__btn-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 2px solid #E6E6E7;
        border-radius: 0.5rem;
        margin: 3rem auto 1rem auto;
        padding: 0.5rem;
        font-size: 0.875rem;
        font-weight: 500;
        max-width: 600px;
    }
}
</style>
